@if (!expanded) {
  <div class="tw-w-full tw-rounded-2xl tw-bg-white tw-max-w-[62vw] tw-min-w-[62vw] tw-overflow-hidden" (click)="cardClick(card.id)">
    <img [src]="card.image" class="tw-w-full">
    <span>
      <img [src]="card.icon" class="tw-w-18 -tw-mt-11 tw-ml-4">
    </span>
    <div class="tw-p-4 tw-pb-7">
      <h1 class="tw-text-500 tw-font-semibold tw-mb-1" [innerHTML]="card.title"></h1>
      <h1 class="tw-text-300 tw-mb-5 tw-font-light tw-pr-7 tw-min-h-15" [innerHTML]="card.subTitle"></h1>
      <span class="tw-text-teal-600 tw-text-400 tw-font-bold tw-flex tw-items-center">
        <span i18n="@@readMore">Read More</span> <img src="https://cdn.cureskin.com/app/img/treatment-philosophy/arrow_forward_teal.svg" class="tw-w-3 tw-ml-1.5">
      </span>
    </div>
  </div>
}
@if (expanded) {
  <div class="tw-w-full tw-max-w-[82vw] xxs:tw-max-h-[90vh] sm:tw-max-h-[75vh] tw-flex tw-items-center tw-justify-center tw-relative">
    <div
      class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-3 tw-right-3 close-sheet"
      style="width: 35px; height: 35px"
      >
      <div class="tw-text-gray-800 tw-text-500 tw-font-bold" (click)="closeCard()">&#10005;</div>
    </div>
    <div class="tw-w-full tw-max-w-sm tw-bg-white tw-rounded-2xl tw-overflow-hidden">
      <img [src]="card.image" class="tw-w-full tw-h-[23vh] tw-object-cover">
      <span>
        <img [src]="card.icon" class="tw-w-18 -tw-mt-10 tw-ml-5">
      </span>
      <div class="tw-px-5 tw-pb-4 tw-pt-4">
        <h1 class="tw-text-600 tw-font-semibold tw-mb-2" [innerHTML]="card.title"></h1>
        <h1 class="tw-text-300 tw-mb-4 tw-font-light" [innerHTML]="card.subTitle"></h1>
        <div class="tw-w-full tw-h-[24vh] sm:tw-h-[20vh] tw-overflow-y-scroll">
          <p class="tw-text-300 tw-font-light">{{card.content}}</p>
        </div>
      </div>
    </div>
  </div>
}
